'use strict';

import Vue from 'vue';
import Router from 'vue-router';
import VueI18n from 'vue-i18n';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

//登录页
const Login = () => import('@/components/NewLogin.vue');
const Login_page = () => import('@/components/Login.vue');
//首页
const index = () => import('@/components/index/index.vue')
//个人中心
const User = () => import('@/components/user/User.vue');
const UserSetting = () => import('@/components/user/page/Setting.vue');
//搜索
const So = () => import('@/components/so/So.vue');
const Navbar = () => import('@/components/so/navbar/Navbar.vue');
const History = () => import('@/components/so/history/History.vue');
const Company = () => import('@/components/so/company/Company.vue');
const SiteList = () => import('@/components/so/list/SiteList.vue');
const EmailList = () => import('@/components/so/list/EmailList.vue');
const ContactList = () => import('@/components/so/list/ContactList.vue');
/*
//邮件
const Email = () => import('@/components/email/Email.vue');
const EmailSetting = () => import('@/components/email/setting/Setting.vue');
const EmailReport = () => import('@/components/email/report/Report.vue');

//客户管理
const Crm = () => import('@/components/crm/Crm.vue');

const Public = () => import('@/components/crm/components/Crm/Public.vue');

const Statistics = () => import('@/components/crm/components/Crm/Statistics.vue');

const TagManagement = () => import('@/components/crm/components/Crm/TagManagement.vue');

const deletedCustomers = () => import('@/components/crm/components/Crm/deleted.vue')
//客户管理-客户详情
const CrmInfo = () => import('@/components/crm/components/Crm/Info.vue');

const CrmInfoBasic = () => import('@/components/crm/components/Crm/info/BasicInfo.vue');

const CrmInfoFollowUp = () => import('@/components/crm/components/Crm/info/FollowUp.vue');

const CrmInfoEmail = () => import('@/components/crm/components/Crm/info/EmailList.vue');
//我的关注
const Focus = () => import('@/components/crm/components/Focus/Focus.vue');
*/


const NotFound = () => import('@/components/NotFound');

const Empty = () => import('@/common/components/empty.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {name: 'index', path: '/index', component: index},
    {name: 'soIndex', path: '/', redirect: '/login'},
    {name: 'login', path: '/login', component: Login},
    {
      name: 'user', path: '/user', component: User,
      children: [
        {name: 'userSetting', path: 'setting', component: UserSetting}
      ]
    },
    {
      name: 'so',
      redirect: '/so/index',
      path: '/so',
      component: So,
      children: [{
          name: 'soNavbar',
          path: 'index',
          component: Navbar
        },
        {
          name: 'soCompany',
          path: 'company',
          components: {
            default: Navbar,
            list: SiteList,
            company: Company
          }
        },
        {
          name: 'soEmail',
          path: 'email',
          components: {
            default: Navbar,
            list: EmailList,
            company: Company,
            contact: ContactList
          }
        },
        {
          name: 'soSingle',
          path: 'single',
          components: {
            default: Navbar,
            list: EmailList,
            contact: ContactList
          }
        },
        {
          name: 'soHistory',
          path: 'history',
          component: History
        }
      ]
    },
    /*
    {
      name: 'email',
      path: '/email',
      redirect: '/email/report',
      component: Email,
      children: [{
          name: 'emailReport',
          path: 'report',
          component: EmailReport
        },
        {
          name: 'emailSetting',
          path: 'setting',
          component: EmailSetting
        }
      ]
    },
    {
      name: 'crm',
      path: '/crm',
      component: Crm,
      redirect: '/crm/crm-private',
      children: [{
          name: 'crm-public',
          path: 'crm-public',
          component: Public
        },
        {
          name: 'crm-private',
          path: 'crm-private',
          component: Public
        },
        {
          name: 'crm-cooperative',
          path: 'crm-cooperative',
          component: Public
        },
        {
          name: 'crm-statistics',
          path: 'crm-statistics',
          component: Statistics
        },
        {
          name: 'crm-tagmanage',
          path: 'crm-tagmanage',
          component: TagManagement
        },
        {
          name: 'crm-deleted',
          path: 'crm-deleted',
          component: deletedCustomers
        }
      ]
    },
    {
      name: 'crm-info',
      path: '/crm-info',
      component: CrmInfo,
      redirect: '/crm-info/crm-basicInfo/:id',
      children: [{
          name: 'crm-basicInfo',
          path: 'crm-basicInfo/:id',
          component: CrmInfoBasic
        },
        {
          name: 'crm-followUp',
          path: 'crm-followUp/:id',
          component: CrmInfoFollowUp
        },
        {
          name: 'crm-email',
          path: 'crm-email/:id',
          component: CrmInfoEmail
        }
      ]
    },
    {
      name: 'crm-focus',
      path: '/crm-focus',
      component: Focus
    },
    */
    {
      path: '*',
      component: NotFound
    },
    {
      path: '/error',
      'name': 'error',
      component: Empty,
      props: {
        scale: 1.8,
        description: 'NO_PERMISSION',
        isTranslated: true
      }
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js